interface RoomSwatchProps {
  swatch: string; // Tailwind CSS class for the swatch color
  name: string; // Name of the room
  hideLabel?: boolean; // Optional prop to hide the label
}

const RoomSwatch = ({ swatch = "bg-blue-500", name = "blue", hideLabel }: RoomSwatchProps) => {
  // White (or other very-light) swatches blend into the table background; nudge a thin grey
  // border on so they remain visible.
  const needsBorder = /\bbg-white\b/.test(swatch);
  return (
    <div className="inline-flex items-center gap-2">
      <span
        className={`w-3 h-3 rounded-full mr-1 ${swatch}${needsBorder ? " border border-gray-300" : ""}`}
      />
      {!hideLabel && <span className="hidden md:block capitalize">{name}</span>}
    </div>
  );
};

export default RoomSwatch;
